import { createI18n } from 'vue-i18n';
import es from './es.json';
import en from './en.json';

export default createI18n({
  legacy: false,
  locale: 'es',
  messages: {
    es,
    en,
  },
});
